/* WW: 搜尋改為前綴比對（options[prefix]=last），讓「帳」可找到「帳篷」。取代 Ella 時期 ww-global.js 的 MutationObserver 版本。 */
(function(){
  function fix(root){
    (root||document).querySelectorAll('form[action$="/search"]').forEach(function(f){
      if(f.querySelector('input[name="options[prefix]"]'))return;
      var i=document.createElement('input');i.type='hidden';i.name='options[prefix]';i.value='last';f.appendChild(i);
    });
  }
  fix();
  document.addEventListener('DOMContentLoaded',function(){fix();});
  document.addEventListener('shopify:section:load',function(){fix();});
})();